import { useState, useEffect, useCallback } from 'react';
import { DashboardResponse, VersionListResponse } from '../types';
import { fetchDashboard, fetchVersions } from '../api/upgradeApi';

interface UseUpgradeDashboardResult {
  dashboard: DashboardResponse | null;
  versions: VersionListResponse | null;
  loading: boolean;
  error: string | null;
  lastRefresh: Date;
  refresh: () => void;
}

export function useUpgradeDashboard(): UseUpgradeDashboardResult {
  const [dashboard, setDashboard] = useState<DashboardResponse | null>(null);
  const [versions, setVersions] = useState<VersionListResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [lastRefresh, setLastRefresh] = useState<Date>(new Date());

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [dashData, verData] = await Promise.all([
        fetchDashboard(),
        fetchVersions(),
      ]);
      setDashboard(dashData);
      setVersions(verData);
      setLastRefresh(new Date());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load upgrade data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { dashboard, versions, loading, error, lastRefresh, refresh };
}
